"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Cover_1 = require("./Cover");
const Indent1_1 = require("./Indent1");
const Indent2_1 = require("./Indent2");
const Indent3_1 = require("./Indent3");
exports.default = [Indent1_1.default, Indent2_1.default, Indent3_1.default, Cover_1.default];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2Jsb2NrX3J1bGVzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsbUNBQTRCO0FBQzVCLHVDQUFnQztBQUNoQyx1Q0FBZ0M7QUFDaEMsdUNBQWdDO0FBQ2hDLGtCQUFlLENBQUUsaUJBQU8sRUFBRSxpQkFBTyxFQUFFLGlCQUFPLEVBQUUsZUFBSyxDQUFFLENBQUMifQ==